import { combineReducers } from "redux";
import userReducer from "./header/user-reducer";
import appReducer from "./header/app-reducer";
import museumsReducer from "./header/museums-reducer";
import authsReducer from "./header/auths-reducer";
import authzReducer from "./header/authz-reducer";
import ownerReducer from "./header/owner-reducer";

var headerReducer = combineReducers({
    user: userReducer,
    app: appReducer,
    museums: museumsReducer,
    auths: authsReducer,
    authz: authzReducer,
    owner: ownerReducer
});

export default headerReducer;